import { CLEAR_SITE_DATA } from '../application';
import { RECEIVE_TAGS } from './actions';

const initialState = {
  tags: [],
};

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_TAGS: {
      const { tags } = action;
      return { ...state, tags };
    }
    case CLEAR_SITE_DATA: {
      // ***IMPORTANT***
      // Explicitly resetting each piece of state here because we've experienced
      // issues with stale state (in visualizations, specifically) - even when returning
      // initialState, using a spread copy of initialState as default state,
      // and/or returning a spread copy of initialState.
      return { ...state, tags: [] };
    }
    default: {
      return state;
    }
  }
}

export default reducer;
